import { StorageDaysOutputWithStatus } from './storage-days-output-with-status.model';


export class StorageDaysSelectByIdOutput implements IStorageDaysSelectByIdOutput {
    status!: number;
    message!: string;
    data!: StorageDaysOutputWithStatus;

    constructor(data?: IStorageDaysSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? StorageDaysOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StorageDaysSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StorageDaysSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IStorageDaysSelectByIdOutput {
    status: number;
    message: string;
    data: StorageDaysOutputWithStatus;
}

